import React from 'react';
import { Home, ArrowRight, ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';
import { useLanguage } from '../contexts/LanguageContext';

/**
 * Reusable "Back to Home" link shown at the top of public pages
 * (loyalty, rate-us, public-booking, login, forgot/reset password, etc.)
 *
 * Uses a plain <a href="/"> so it works in every browser, supports
 * middle-click / open-in-new-tab, and degrades gracefully if router
 * context is missing.
 */
const BackToHome = ({ className = '' }) => {
  const { language } = useLanguage();
  const isArabic = language === 'ar';

  return (
    <div
      className={`w-full max-w-md mx-auto mb-4 flex justify-start ${className}`}
      dir={isArabic ? 'rtl' : 'ltr'}
    >
      <Button
        asChild
        variant="ghost"
        size="sm"
        className="text-muted-foreground hover:text-primary gap-2"
        data-testid="back-to-home-btn"
      >
        <a href="/">
          <Home className="h-4 w-4" />
          {isArabic ? 'الصفحة الرئيسية' : 'Home'}
          {isArabic ? <ArrowLeft className="h-4 w-4" /> : <ArrowRight className="h-4 w-4" />}
        </a>
      </Button>
    </div>
  );
};

export default BackToHome;
